@if (groupSelection && selectedImageIdsSignal().length > 0) {
  <div class="absolute -top-2 h-6 w-full px-2">
    <div
      class="h-full w-full rounded-2xl border-x-2 border-t-2 border-primary-blue"
      [ngClass]="{
        'bg-primary-blue': groupSelectionSize === selectedImageIdsSignal().length
      }"
    ></div>
  </div>
}
<div
  [ngClass]="{
    'h-[136px]': size === 'auto' || size === 'normal',
    'w-[152px]': size === 'normal',
    'aspect-square': size === 'square',
    'w-[368px]': size === 'support-collab',
    'h-[248px]': size === 'support-collab',
    'before:border-primary-blue': selectedSignal(),
    'before:border-text-white': !selectedSignal()
  }"
  class="relative rounded-2xl bg-background-white p-1.5 before:absolute before:inset-0 before:rounded-2xl before:border-2"
>
  <div class="flex h-full flex-col overflow-hidden rounded-xl bg-background-white shadow-attachment-element">
    <button class="relative z-10 flex-1 overflow-hidden">
      <div class="pointer-events-auto h-full bg-text-extra-light">
        @if (attachment) {
          @switch (attachment.mediaType) {
            @case (MediaType.IMAGE) {
              <div
                class="grid h-full w-full"
                [libPreviewImage]="(attachment.url ?? (attachment.id | fileUrl | async)) || ''"
                [file]="attachment.file"
                [showPreview]="preview"
                [fileId]="attachment.id"
                [ffdPushTagOnClick]="{
                  event: TagEvent.CollaborationImagePreviewed,
                  type: 'single',
                  patient_id: patientId() ?? undefined
                }"
              >
                <ng-template [ngTemplateOutlet]="imageThumbnail"></ng-template>
              </div>
            }
            @case (MediaType.RECORDING) {
              <div
                class="relative grid h-full w-full"
                libPreviewVideo
                [videoUrl]="attachment.url"
                [file]="attachment.file"
                [thumbnailUrl]="size === 'support-collab' ? supportCollabThumbnailUrl : attachment.thumbnailUrl || ''"
                [fileType]="attachment.url && attachment.file ? attachment.file.type : ''"
                [fileId]="attachment.id"
                [showPreview]="preview"
              >
                <ng-template [ngTemplateOutlet]="videoThumbnail"></ng-template>
                <svg-icon
                  *ngIf="thumbnailLoaded() || attachment.url"
                  class="z-10 col-start-1 row-start-1 place-self-center"
                  key="px-40-play-white"
                  size="xl"
                ></svg-icon>
              </div>
            }
          }

          <ng-template #imageThumbnail>
            <img
              crossorigin="anonymous"
              class="pointer-events-auto col-start-1 row-start-1 h-full w-full overflow-hidden object-contain"
              [src]="(attachment.thumbnailUrl ?? (attachment.id | attachmentThumbnail | async)) || ''"
              [hidden]="!thumbnailLoaded()"
              (load)="thumbnailLoaded.set(true)"
            />
          </ng-template>
          <ng-template #videoThumbnail>
            @if (attachment.url) {
              <div class="absolute left-0 top-0 h-full w-full bg-text-extra-light/20"></div>
              <video
                crossorigin="anonymous"
                class="pointer-events-none col-start-1 row-start-1 h-full w-full object-contain"
                [src]="attachment.url"
              ></video>
            } @else {
              <div
                class="absolute left-0 top-0 h-full w-full"
                [ngClass]="size === 'support-collab' ? 'bg-text-primary/50' : 'bg-text-tertiary/20'"
              ></div>

              <img
                crossorigin="anonymous"
                class="pointer-events-auto col-start-1 row-start-1 h-full w-full overflow-hidden object-contain"
                [src]="
                  size === 'support-collab'
                    ? supportCollabThumbnailUrl
                    : (attachment.thumbnailUrl ?? (attachment.id | attachmentThumbnail | async)) || ''
                "
                [hidden]="!thumbnailLoaded()"
                (load)="thumbnailLoaded.set(true)"
              />
              @if (!thumbnailLoaded()) {
                <img src="assets/images/collab-thumbnail-preview.png" class="col-start-1 row-start-1 h-full w-full" />
              }
            }
          </ng-template>
        } @else {
          <ng-content></ng-content>
        }
      </div>
    </button>
    <ng-content select="[details]"></ng-content>
  </div>
</div>
